import { render, staticRenderFns } from "./SchemaForm.vue?vue&type=template&id=278178ec"
import script from "./SchemaForm.vue?vue&type=script&lang=js"
export * from "./SchemaForm.vue?vue&type=script&lang=js"
import style0 from "./SchemaForm.vue?vue&type=style&index=0&id=278178ec&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports